import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b684670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "button-container" }
const _hoisted_2 = ["hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarItem = _resolveComponent("ToolbarItem")!

  return (_openBlock(), _createBlock(_component_ToolbarItem, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("button", {
          key: !_ctx.displayClose(),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePnpTool()))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass([_ctx.icon, "icon fa fa-fw mr-2"])
          }, null, 2),
          _createElementVNode("span", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("i", {
            hidden: !_ctx.displayClose(),
            class: "icon close-icon fa fa-times-circle"
          }, null, 8, _hoisted_2)
        ]))
      ])
    ]),
    _: 1
  }))
}